import * as types from './actionTypes';

export const addBills = (bills) => (
    {
        type: types.ADD_BILLS,
        bills,
    }
);

export const setBills = (bills) => (
    {
        type: types.SET_BILLS,
        bills,
    }
);

export const startLoading = () => (
    {
        type: types.START_LOADING,
    }
);

export const setEndReached = () => (
    {
        type: types.SET_END_REACHED,
    }
);

export const setRefund = (sum, transactionId, vkId) => (
    {
        type: types.SET_REFUND,
        sum,
        transactionId,
        vkId,
    }
);

export const setRefundSum = (sum) => (
    {
        type: types.SET_REFUND_SUM,
        sum,
    }
);

export const setBillRefund = (transactionId, sum, date) => (
    {
        type: types.SET_BILL_REFUND,
        transactionId,
        sum,
        date,
    }
);

export const setPaySum = (paySum) => (
    {
        type: types.SET_PAY_SUM,
        paySum,
    }
);

export const addBillAtStart = (bill) => (
    {
        type: types.ADD_BILL_AT_START,
        bill,
    }
);

export const setTodaySum = (todaySum, todayRefund) => (
    {
        type: types.SET_TODAY_SUM,
        todaySum,
        todayRefund,
    }
);


// WEBPACK FOOTER //
// ./src/js/store/bills/actions.js